












import Vue from 'vue';
import { VBTooltip } from 'bootstrap-vue';

export interface ItemStatus {
  status: string;
  hint: string;
  color: string;
}

export default Vue.extend({
  name: 'ItemStatusIndicator',
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
    statuses: {
      type: Array as () => ItemStatus[],
      default: () =>
        [
          {
            status: 'invalid',
            hint: 'Invalid',
            color: '#ef4853',
          },
          {
            status: 'dirty',
            hint: 'Unsaved',
            color: '#ffac1f',
          },
        ] as ItemStatus[],
    },
  },
  computed: {
    style() {
      let status = this.statuses.find(s => s.status === this.status);
      return status ? `background-color: ${status.color};` : '';
    },
    hint() {
      let status = this.statuses.find(s => s.status === this.status);
      return status ? status.hint : '';
    },
  },
});
